var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.questionTitle))]),(_vm.questionDescription)?_c('b-message',[_vm._v(_vm._s(_vm.questionDescription))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }